export var TOKENS_PER_PAGE = 1000;
export var RARITY_LOWER_BOUND = 1;
export var RARITY_UPPER_BOUND = 100;
export var MAX_COLLECTION_SIZE = 20000;
export var MAX_ASSET_COUNT = 500;
export var MAX_TOKEN_DOWNLOADS = 50;
export var ZIP_TOKENS_PER_PAGE = 1000;
export var ADMIN_HTTP_HEADER = "x-lasagna-admin-user";
export var PREVIEW_ID_QUERY_PARAM = "share_id";
export var INITIAL_FEE = 499;
export var PRICE_PER_TOKEN = 1;
export var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export var SQUARE_MINIMUM_CHARGE = 100;
